module.exports = __webpack_public_path__ + "static/media/check-mark-button.238349ad.svg";